import React from 'react';
import { BreadcrumbProps, Button, Icon, NumberDisplay, Tooltip } from '@aidkitorg/component-library';
import { usePayments } from '../../Contexts/PaymentsContext';
import { useLocalizedStrings } from '../../Localization';
import { AdminPanelPage } from '../AdminPanelPage';
import { PaymentsDataTable } from './components/PaymentsDataTable';
import { usePaymentsOverviewConfig } from '../shared/hooks/useAdminPanelPageConfig';

export const PaymentsPage = () => {
  const L = useLocalizedStrings()

  const {
    fetchPaymentsOverview,
    enabledPayments,
    disabledPayments,
    paymentsDataTimestamp,

    isPaymentsLoading
  } = usePayments();

  // Fetch page configuration using the hook
  const {
    pageConfig,
    isLoading: isConfigLoading,
    getLocalizedText,
    isVisible
  } = usePaymentsOverviewConfig();

  // Use config to determine what to show
  const showEnabledPayments = isVisible(['summaryMetrics', 'enableTotalPayments']);
  const showDisabledPayments = isVisible(['summaryMetrics', 'enableDisabledPayments']);
  const pageTitle = getLocalizedText(['pageHeader', 'title'], L.admin_panel.nav.payments);
  const pageDescription = getLocalizedText(['pageHeader', 'description'], L.admin_panel.payments.payments_about);

  const enabledPaymentsCard = showEnabledPayments ? (
    <NumberDisplay
      loading={isPaymentsLoading}
      className="sm:max-w-64 min-w-64"
      title={L.admin_panel.payments.enabled_payments}
      value={enabledPayments}
      unit={L.admin_panel.payments.payments}
      unitSingular={L.admin_panel.payments.payment}
      iconName="PlayCircleIcon"
      iconColor="blue"
    />
  ) : null;

  const disabledPaymentsCard = showDisabledPayments ? (
    <NumberDisplay
      loading={isPaymentsLoading}
      className="sm:max-w-64 min-w-64"
      title={L.admin_panel.payments.disabled_payments}
      value={disabledPayments}
      unit={L.admin_panel.payments.payments}
      unitSingular={L.admin_panel.payments.payment}
      iconName="PauseCircleIcon"
      iconColor="gray"
    />
  ) : null;

  const breadcrumbs: BreadcrumbProps['items'] = [
    {
      label: L.admin_panel.nav.accounting,
    },
    {
      label: L.admin_panel.nav.payments
    }
  ];

  return (
    <AdminPanelPage
      title={pageTitle}
      description={pageDescription}
      breadcrumbs={breadcrumbs}
      pageActionButtons={[
        <Tooltip text={L.admin_panel.payments.refresh_data} asChild>
          <Button
            size="sm"
            variant='secondary'
            onClick={() => { fetchPaymentsOverview(true) }}
            icon={<Icon role="decorative" type="solid" name="ArrowPathIcon" />}
            aria-label={L.admin_panel.payments.refresh_data}
          />
        </Tooltip>
      ]}
    >
      <div className="flex flex-col gap-2 sm:gap-4 w-full">
        {(enabledPaymentsCard || disabledPaymentsCard) && (
          <div className="flex flex-col sm:flex-row gap-2 sm:gap-4">
            {enabledPaymentsCard}
            {disabledPaymentsCard}
          </div>
        )}
        <div>
          <PaymentsDataTable
            lastUpdatedTimestamp={paymentsDataTimestamp}
            pageConfig={pageConfig}
            isConfigLoading={isConfigLoading}
          />
        </div>
      </div>
    </AdminPanelPage>
  )
}